// extracted by mini-css-extract-plugin
module.exports = {"area":"area___35Pnp","title":"title___2T9HR","source":"source___8j0cB"};